<template>
  <v-content style="background-color: #F8F8F8">
    <loading
      color="#FD5246"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>

    <!-- <pre class="warning" v-if="user">
      {{ user }}
    </pre> -->

    <!-- header -->
    <Header id="header"></Header>

    <v-layout
      id="menu"
      class="justify-center mt-4"
      style="background-color: #F8F8F8"
      v-if="activeMenu()"
    >
      <v-flex xs12 px-lg-12 px-md-12 px-sm-12 px-0 class="text-center">
        <SlideGroup
          :onClickCategory="onclickCategory"
          :category_id="category_id"
        ></SlideGroup>
      </v-flex>
    </v-layout>

    <!-- min-height: 100vh; -->
    <v-layout
      style=" background-color: #F8F8F8"
      class="my-4 px-lg-12 px-md-12 px-sm-12 px-0"
    >
      <!-- Body -->
      <template>
        <v-content id="body">
          <router-view />
        </v-content>
      </template>
    </v-layout>

    <!-- <VueFbCustomerChat /> -->

    <Footer id="footer"></Footer>
  </v-content>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import SlideGroup from "../components/slide_group/SlideGroup";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";

export default {
  name: "MainLayout",
  components: {
    Header,
    Footer,
    SlideGroup,
    Loading,
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    ...mapState({
      user: (state) => {
        return state.auth.users;
      },
      // category_id: (state) => {
      //   return state.portfolio.portfolio_categorys.category_id;
      // },
      switchLanguage: (state) => {
        return state.Common.switchLanguage;
      },
    }),
    category_id() {
      return this.getCateId();
    },
  },
  data: () => ({
    isLoading: false,
    fullPage: true,
    height: "515",
  }),
  methods: {
    onclickCategory(item) {
      this.$router
        .push(
          `/portfolio-category/${
            this.switchLanguage === "th" ? item.name_th : item.name_en
          }${item.name_th === "รวม" ? "" : "-" + item.id}`
        )
        .catch(() => {});

      // let data = { id: item.id, page: 1 };
      // this.isLoading = true;
      // this.$store
      //   .dispatch("portfolio/getPortfolioByIdCategory", data)
      //   .then((res) => {
      //     this.isLoading = false;
      //     // if (this.currentRouteName !== "AllPortfolioByCategory") {
      //     this.$router
      //       .push(
      //         `/portfolio-category/${
      //           this.switchLanguage === "th" ? item.name_th : item.name_en
      //         }`
      //       )
      //       .catch(() => {});
      //     // }
      //   })
      //   .catch((e) => {
      //     this.isLoading = false;
      //   });
    },
    activeMenu() {
      return (
        this.currentRouteName === "HomePage" ||
        this.currentRouteName === "AllPortfolioByCategory"
      );
    },
  },
};
</script>

<style scoped>
.footer {
  /*position: fixed;*/
  /*left: 0;*/
  /*bottom: 0;*/
  /*width: 100%;*/
  /*background-color: red;*/
  /*color: #F8F8F8;*/
  /*text-align: center;*/
  position: relative;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #f8f8f8;
  text-align: center;
}

/*}*/
</style>
